<template>
  <div>
    <a-spin :spinning="loading">
      <p class="text-dark font-weight-bold mb-2">Payment Gateway Settings</p>
      <hr>
      <a-form class="mb-4" :form="form">
        <div class="row">
          <div class="col-12 col-md-6">
            <a-form-item label="Key ID">
              <a-input-password
                placeholder="Razorpay key id"
                v-decorator="['key_id', {rules: [{ required: false, message: 'Please input key id!' }]}]"
              />
            </a-form-item>
          </div>
          <div class="col-12 col-md-6">
            <a-form-item label="Key Secret">
              <a-input-password
                placeholder="Razorpay key secret"
                v-decorator="['key_secret', {rules: [{ required: false, message: 'Please input key secret' }]}]"
              />
            </a-form-item>
          </div>
        </div>
        <div class="my-2">
          <input type="submit" value="submit" class="d-none"/>
          <a-button key="submit" type="primary" :loading="loading" @click="handleSubmit">Save</a-button>
        </div>
      </a-form>
    </a-spin>
  </div>
</template>

<script>

export default {
  name: 'PaymentGateway',
  mounted: function() {
    this.getPaymentSettings()
  },
  computed: {
    schoolId: function () {
      return this.$route.params.id
    },
  },
  data: function() {
    return {
      form: this.$form.createForm(this),
      loading: false,
    }
  },
  methods: {
    getPaymentSettings() {
      this.loading = true
      this.$http.get(`/api/school/payment_settings/${this.schoolId}`)
        .then(({ data }) => {
          this.form.setFieldsValue(data.data)
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$neoNotify.error(error)
        })
    },

    handleSubmit(e) {
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$confirm({
            title: `Are you sure?`,
            content: `Click on the OK button to update payment settings!`,
            onOk: () => {
              this.$http
                .post('/api/school/payment_settings/' + this.schoolId, {
                  key_id: values.key_id,
                  key_secret: values.key_secret,
                })
                .then(({ data }) => {
                  this.$emit('saved')
                  this.loading = false
                  this.$notification['success']({
                    message: 'Settings updated!',
                    description: 'Payment settings has been updated successfully.',
                  })

                  this.getPaymentSettings()
                })
                .catch(error => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        }

        this.loading = false
      })
    },
  },
}
</script>
